<template>
  <div class="window-controls" v-if="isElectron">
    <v-btn icon @click="minimize">
      <v-icon>mdi-window-minimize</v-icon>
    </v-btn>
    <v-btn icon @click="maximize">
      <v-icon>mdi-window-maximize</v-icon>
    </v-btn>
    <v-btn icon @click="close">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'WindowControls',
  data: () => ({
    isElectron: window.electron !== undefined
  }),
  methods: {
    minimize() {
      if (this.isElectron) {
        window.electron.minimize()
      }
    },
    maximize() {
      if (this.isElectron) {
        window.electron.maximize()
      }
    },
    close() {
      if (this.isElectron) {
        window.electron.close()
      }
    }
  }
}
</script>

<style scoped>
.window-controls {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  background: transparent;
}
</style> 